import * as OrgConfig from "src/generated/hooks/org-config/requests";
import * as RD from "src/types/remoteData";
import { DeepReadonly } from "src/types/utils";
import { useOrgConfig } from "./useOrgConfig";

const DefaultConfig = OrgConfig.TranslationOptionsConfigSchema.default;

export function useTranslationOptions(): RD.RemoteData<
  unknown,
  DeepReadonly<OrgConfig.TranslationOptionsConfig>
> {
  const configRD = useOrgConfig<OrgConfig.TranslationOptionsConfig>(
    "TranslationOptions",
    DefaultConfig
  );
  const defaultConfig = OrgConfig.TranslationOptionsConfigSchema.default;

  if (defaultConfig) {
    return configRD.recover(() => RD.success(defaultConfig));
  }

  return configRD;
}
